import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[enaukaScrollable]'
})
export class ScrollableDirective implements OnInit {
  @Input('selectable')
  private menuSelector: string = '.main-header>nav';
  private SCROLL_MS = 1000;
  private scrollable;
  private menu;
  constructor(private element: ElementRef) {
  }


  ngOnInit(): void {
    this.init(this.element.nativeElement, this.menuSelector);
  }

  private init(scrollableSelector, menuSelector) {
    this.initElements(scrollableSelector, menuSelector);
    this.bindEvents();
  }

  private initElements(scrollableSelector, menuSelector) {
    this.scrollable = $(scrollableSelector);
    this.menu = $(menuSelector);
  }

  private bindEvents() {
    this.scrollable.on('click', this.scroll);
  }

  scroll = (event) => {
    event.preventDefault();

    var target = $(this.element.nativeElement).attr('href');
    $('html, body').animate({
      scrollTop: $(target).offset().top - this.menu.outerHeight()
    }, this.SCROLL_MS);
  }
}
